import { useEffect, useState } from 'react';

const useScreenHeight = () => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    setValue(document.documentElement.scrollHeight);
  }, []);

  return value;
};

export default useScreenHeight;
